<template>
  <div id="modal" class="modal product_search_modal" v-show="modalShown">
    <div id="product_search_main" v-bind:class="{'modal-main' : true, wrapper : true, search_height : true}">
      <div class="cross_btn2" @click="cancel()">
        <span class="css-cancel"></span>
      </div>
      <div class="modal_content_main">
        <section class="select_category"> <!-- 商品カテゴリ -->
          <h3>カテゴリーで絞り込む</h3>
          <div>
            <div v-for="(category, index) in categoryList" :key="'cate_' + index">
              <div v-bind:class="{cetegory_item: true, active: isSelCategory(category.id)}" @click="selectCategory(category)">
                <div>
                  <img :src="categoryImgBlack(category.img)" v-if="!isSelCategory(category.id)">
                  <img :src="categoryImgBlack(category.img)" v-else>
                </div>
                <div>{{categoryName(category.name)}}</div>
              </div>
            </div>
          </div>
        </section>
        <section> <!-- 対応サイズ -->
          <h3>サイズで絞り込む</h3>
          <div class="storage_size_area">
            <div class="storage_size">
              <div>幅 (mm)</div>
              <div><input type="text" v-model.number="paramsForm.minWidth" @keypress="validateNumber" @input="paramsForm.minWidth=inputRestNumber($event)" @blur="onBlurStorageItemMinW" @focus="selectedAll"></div>
            </div>
            <div class="storage_size">
              <div>高さ (mm)</div>
              <div><input type="text" v-model.number="paramsForm.minHeight" @keypress="validateNumber" @input="paramsForm.minHeight=inputRestNumber($event)" @blur="onBlurStorageItemMinH" @focus="selectedAll"></div>
            </div>
            <div class="storage_size">
              <div>奥行き (mm)</div>
              <div><input type="text" v-model.number="paramsForm.minDepth" @keypress="validateNumber" @input="paramsForm.minDepth=inputRestNumber($event)" @blur="onBlurStorageItemMinD" @focus="selectedAll"></div>
            </div>
          </div>
        </section>
      </div>
      <section class="product_search_action"> <!-- 操作 -->
        <div class="dialog_btn_black" @click="search()" v-on:mouseover="isOnSearch(true)" v-on:mouseleave="isOnSearch(false)">
          <div>絞り込む</div>
        </div>
        <div class="dialog_btn_white" @click="reset()" v-on:mouseover="isOnReset(true)" v-on:mouseleave="isOnReset(false)">
          <div>条件リセット</div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import * as App from '../../../../../utils/App'
// import {DC_STORAGE_KEY} from '../../../../../constants/App'
import * as FormUtil from '../../../../../utils/FormUtil'
import * as Check from '../../../../../utils/Check'

export default {
  name: 'estimateModal',
  components: {
  },
  props: {
    categoryList: Array,
    paramsForm: Object,
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    onCancel: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      newCnt: 0,
      selCategoryList: [],
      errors: {}
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    reset: function () {
      this.errors = {}
      this.newCnt = 0
      this.paramsForm.minWidth = undefined
      this.paramsForm.maxWidth = undefined
      this.paramsForm.minHeight = undefined
      this.paramsForm.maxHeight = undefined
      this.paramsForm.minDepth = undefined
      this.paramsForm.maxDepth = undefined
      this.paramsForm.makerIdList = []
      this.selCategoryList = []
    },
    search: function () {
      if (!this.modalShown) return
      this.errors = {}
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      this.callbackParams = {
        categoryList: this.selCategoryList,
        minWidth: this.paramsForm.minWidth,
        maxWidth: this.paramsForm.maxWidth,
        minHeight: this.paramsForm.minHeight,
        maxHeight: this.paramsForm.maxHeight,
        minDepth: this.paramsForm.minDepth,
        maxDepth: this.paramsForm.maxDepth,
        makerIdList: this.paramsForm.makerIdList
      }
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    cancel: function () {
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getYasumokuResource(image)
    },
    isOnReset: function () {
    },
    isOnSearch: function () {
    },
    onBlurStorageItemMinW: function () {
      if (!this.paramsForm.minWidth || this.paramsForm.minWidth < 0) {
        this.paramsForm.minWidth = undefined
      }
    },
    onBlurStorageItemMinH: function () {
      if (!this.paramsForm.minHeight || this.paramsForm.minHeight < 0) {
        this.paramsForm.minHeight = undefined
      }
    },
    onBlurStorageItemMinD: function () {
      if (!this.paramsForm.minDepth || this.paramsForm.minDepth < 0) {
        this.paramsForm.minDepth = undefined
      }
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    selectedAll: function (event) {
      event.target.select()
    },
    selectCategory: function (category) {
      // カテゴリ変更処理
      if (this.selCategoryList.find(c => c.id === category.id)) {
        this.selCategoryList = this.selCategoryList.filter(c => c.id !== category.id)
      } else {
        this.selCategoryList.push(category)
      }
      this.$forceUpdate()
    },
    isSelCategory: function (id) {
      return this.selCategoryList.find(c => c.id === id)
    },
    categoryImgBlack: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    categoryImgWhite: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_white' + exp)
    },
    categoryName: function (name) {
      if (!name) return ''
      console.log('param:' + name)
      const s = name.replace('（', '\n（')
      return s
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    if (this.categoryList) {
      this.selCategoryList = this.categoryList.filter(c => this.paramsForm.categoryList.includes(c.id))
    }
  }
}
</script>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/search/DcProductSearchModal.vue